import type {DomAndDmContext} from '../types'
import {executeWithRenderAndHistory} from './utils/executeWithRenderAndHistory'
import type {MobileAlgoExtensionApi} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/mobileAlgo'
import {getSections} from './utils/sections'
import type {DAL} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'

const getMobileBreakpoint = (dmContext: DomAndDmContext, compRef: CompRef) => {
    const breakpointsData = dmContext.documentServices.breakpoints.get(compRef)

    if (!breakpointsData) {
        return null
    }

    const [, index] = breakpointsData.values.reduce(
        (previousValue: number[], currentValue, currentIndex): number[] => {
            if (currentValue.max !== undefined && currentValue.max < previousValue[0]) {
                return [currentValue.max, currentIndex]
            }

            return previousValue
        },
        [Infinity]
    )

    if (index === undefined) {
        return null
    }

    return [breakpointsData.pointers[index]]
}

export const run = async (dmContext: DomAndDmContext, dal: DAL): Promise<void> => {
    const currentPageSections = getSections(dal, dmContext.documentServices.pages.getCurrentPageId())
    const {mobileAlgo} = dmContext.documentManager.extensionAPI as MobileAlgoExtensionApi
    const pageMobileBreakpoint = getMobileBreakpoint(dmContext, dmContext.documentServices.pages.getCurrentPage())
    executeWithRenderAndHistory(dmContext, async () => {
        await Promise.all(
            currentPageSections.map((sectionId: string) => {
                const sectionPointer = {id: sectionId, type: 'DESKTOP'} as CompRef
                return mobileAlgo.run(sectionPointer, {
                    targetVariants: getMobileBreakpoint(dmContext, sectionPointer) ?? pageMobileBreakpoint
                } as any)
            })
        )
    })
}
